import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { forkJoin, of } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';
import { ICalendarioMaquina } from 'src/app/usuarios/models/IMaquinaFecha';
import { IMaquinaEstadoResponse } from '../models/maquina';
import { MaquinaService } from '../services/maquina.service';
import {
  loadMaquinas,
  loadedMaquinasError,
  loadedMaquinasSuccess
} from './maquina.actions';

@Injectable()
export class MaquinaEffects {
  constructor(private actions$: Actions, public dataService: MaquinaService) {
    this.loadMaquinas$ = createEffect(() =>
      this.actions$.pipe(
        ofType(loadMaquinas),
        switchMap((payload: { usuarioId: number; empresaId: number; fechaDesde: any }) => {
          return forkJoin({
            maquinas: this.dataService.getByUsuario(payload.empresaId, payload.usuarioId),
            calendario: this.dataService.getCalendarioByEmpresa(payload.empresaId, payload.fechaDesde),
          }).pipe(
            map((response: { maquinas: IMaquinaEstadoResponse; calendario: ICalendarioMaquina[] }) => {
              return loadedMaquinasSuccess({
                maquinas: response.maquinas,
                calendario: response.calendario,
              });
            }),
            catchError((error) => {
              console.error("Error en loadMaquinas$", error);
              return of(loadedMaquinasError({ error }));
            })
          );
        })
      )
    );
  }

  loadMaquinas$?: unknown;
}

